import { render, staticRenderFns } from "./ChinaMap.vue?vue&type=template&id=4bb49f1e&scoped=true"
import script from "./ChinaMap.vue?vue&type=script&lang=js"
export * from "./ChinaMap.vue?vue&type=script&lang=js"
import style0 from "./ChinaMap.vue?vue&type=style&index=0&id=4bb49f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb49f1e",
  null
  
)

export default component.exports